'use client';

import Lottie from 'lottie-react';
import animationData from '../../../public/loading.json';

interface LottieLoaderProps {
  loop?: boolean;
  onComplete?: () => void;
}

export default function LottieLoader({
  loop = true,
  onComplete,
}: LottieLoaderProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="w-[150px] h-[150px]">
        <Lottie
          animationData={animationData}
          loop={loop}
          autoplay={true}
          onComplete={onComplete}
        />
      </div>
    </div>
  );
}
